import { Typography } from "src/components/shared";

export const SummitHero = ({ content }: { content: any }) => {
    const heroDescription = content?.heroFieldDescriptionJson?.json?.content?.[0]?.content?.[0]?.value ?? "";
    
    return (
      <div className="d-flex flex-column align-items-start pe-m-0 max-w-450">
        <Typography
          tag="h2" 
          style={{ display: 'inline-block', maxWidth: 'calc(14ch)', whiteSpace: 'normal' }}
          className="mb-20"
        >
          {content?.title}
        </Typography>
        <Typography tag="p" className="grey-medium-dark mx-w-450 mb-20">
          {heroDescription}
        </Typography>
      </div>
    );
  };